import { Button, Stack, Typography } from "@mui/material";
import CustomInput from "../../components/CustomInput";

export default function WhatsappWidget() {
  return (
    <div
      style={{
        maxWidth: "90%",
        margin: "auto"
      }}
    >
      <Typography variant="h3">Whatsapp Widget Integration</Typography>
      <Typography variant="body1">Whatsapp Mobile Number</Typography>
      <CustomInput placeholder="Enter your Whatsapp mobile number" />
      <small>
        Please enter your phone number with country code eg. +911234567890
      </small>
      <br />
      <br />
      <Typography variant="body1">Default Message</Typography>
      <CustomInput placeholder="Hi, I have a query regarding your learning community " />
      <Stack direction="row" justifyContent="end">
        <Button sx={{ marginBlock: 2 }} variant="contained">
          Save
        </Button>
      </Stack>
    </div>
  );
}
